"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import styles from "./TestimonialsSection.module.css";

const items = [
  {
    name: "Impeccable Servers",
    text: "Using Temok for a very long time now, moved from another host because they weren’t able to keep my website clean from attacks — now with Temok, the past few years have gone very smoothly without having to worry about technical stuff.",
    desc: "Zy Elmore — CEO",
  },
  {
    name: "Using Temok for a very long time now",
    text: "Using Temok for a very long time now, moved from another host because they couldn’t stop repeated attacks. With Temok everything has been smooth and stress-free.",
    desc: "Uttoran Sen",
  },
  {
    name: "Happy that I found them",
    text: "I am using their services for more than a year. So far no issues. Customer support responds quickly whenever I have questions.",
    desc: "Pavel Chintea — CEO",
  },
  {
    name: "Impeccable Servers",
    text: "I started using Temok when I needed a reliable server. They provided a great domain and hosting bundle at a discounted price.",
    desc: "Zy Elmore — CEO",
  },
  {
    name: "Impeccable Servers",
    text: "Using Temok for a very long time now, moved from another host because they weren’t able to keep my website clean from attacks — Temok has been exceptional.",
    desc: "Zy Elmore — CEO",
  },
  {
    name: "Using Temok for a very long time now",
    text: "Using Temok for a very long time now, moved from another host because they weren’t able to secure my site properly.",
    desc: "Uttoran Sen",
  },
  {
    name: "Happy that I found them",
    text: "I am using their services for more than a year. Their support is fast and always helpful.",
    desc: "Pavel Chintea — CEO",
  },
  {
    name: "Impeccable Servers",
    text: "They helped me set up a domain and website for a great price and provided excellent server reliability.",
    desc: "Zy Elmore — CEO",
  },
];

const TestimonialsSection: React.FC = () => {
  return (
    <section id="testimonials-section" className={`container-lg py-5 ${styles.section}`}>
      
      {/* Heading */}
      <div className={styles.Haddings}>
        <h4 className="fw-bold text-center my-3">Clients Testimonials</h4>
      </div>

      {/* Swiper */}
      <Swiper
        className="mt-4 px-2 px-md-4"
        modules={[Navigation, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        autoplay={{ delay: 2500 }}
        breakpoints={{
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <div className={`${styles.testimonialsBg} p-4 rounded-4`}>
              <h6 className={`${styles.textHad0} fw-bold`}>{item.name}</h6>
              <p className={`${styles.testimonialsClr} mb-2`}>{item.text}</p>
              <pre className={`${styles.testimonialsClr0} mt-2`}>{item.desc}</pre>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </section>
  );
};

export default TestimonialsSection;
